"use client";

// Das „…“ am Ende einer Rechnungszeile. Was hier steht, geht auch
// auf dem Blatt — die Zeile erspart nur den Weg dorthin.
import { useRouter } from "next/navigation";
import { Copy, Download, Euro, FileText } from "lucide-react";
import { DropdownItem, DropdownMenu, DropdownSeparator } from "@/components/ui/dropdown-menu";
import { MehrKnopf } from "@/components/ui/zeichen-knopf";
import { UEBER_DER_ZEILE } from "@/components/liste";

export function RechnungZeilenmenue({
  id,
  nummer,
  offen,
  zahlbar,
  kopierbar = true,
}: {
  id: string;
  nummer: string | null;
  offen: number;
  zahlbar: boolean;
  kopierbar?: boolean;
}) {
  const router = useRouter();
  return (
    <div className={UEBER_DER_ZEILE}>
      <DropdownMenu trigger={<MehrKnopf groesse="mittel" label={`Aktionen zu ${nummer ?? "Entwurf"}`} />}>
        <DropdownItem onClick={() => router.push(`/rechnungen/${id}`)}>
          <FileText className="h-4 w-4" aria-hidden /> Öffnen
        </DropdownItem>
        {zahlbar && offen > 0 && (
          <DropdownItem onClick={() => router.push(`/rechnungen/${id}?aktion=zahlung`)}>
            <Euro className="h-4 w-4" aria-hidden /> Zahlung erfassen
          </DropdownItem>
        )}
        {/* Festgeschrieben: das eingefrorene Blatt; Entwurf: frisch gesetzt mit „Entwurf“ darüber. */}
        <DropdownItem onClick={() => window.open(`/api/rechnungen/${id}/pdf?download=1`, "_self")}>
          <Download className="h-4 w-4" aria-hidden /> PDF herunterladen
        </DropdownItem>
        {kopierbar && (
          <>
            <DropdownSeparator />
            <DropdownItem onClick={() => router.push(`/rechnungen/neu?vorlage=${id}`)}>
              <Copy className="h-4 w-4" aria-hidden /> Als neue Rechnung kopieren
            </DropdownItem>
          </>
        )}
      </DropdownMenu>
    </div>
  );
}
